import { ConfirmDialog } from '@core/components';
import { useConfirmDialog } from '@core/hooks/useConfirmDialog';
import { type Order, cancelOrder } from '../../api/order';

interface CancelOrderDialogProps {
  open: boolean;
  onClose: () => void;
  order: Order | null;
  onSuccess?: () => void;
}

const CancelOrderDialog = ({
  open,
  onClose,
  order,
  onSuccess,
}: CancelOrderDialogProps) => {
  const { loading, confirm, cancel } = useConfirmDialog({
    open,
    onClose,
    onConfirm: async () => {
      if (!order) return;
      await cancelOrder(order.id);
    },
    onSuccess,
    successMessage: 'Order cancelled',
    errorMessage: 'Failed to cancel order',
  });

  return (
    <ConfirmDialog
      open={open}
      title="Cancel order"
      content="This order will be marked as cancelled and removed from production tracking. Continue?"
      confirmText="Cancel order"
      cancelText="Keep order"
      onConfirm={confirm}
      onCancel={cancel}
      loading={loading}
    />
  );
};

export default CancelOrderDialog;
